module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers clearfix",
    attrs: {
      "id": "pers-invest",
      "name": "hres8ax-invest"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "cal-input-group clearfix"
  }, [_c('div', {
    staticClass: "cal-topic clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3 "
  }, [_c('div', {
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-label clear-padding",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC3']['90']))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-input clear-padding"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailInvest.amtD10),
      expression: "detailInvest.amtD10"
    }],
    staticClass: "form-control input-text",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "id": "n_name",
      "name": "n_name"
    },
    domProps: {
      "value": (_vm.detailInvest.amtD10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detailInvest, "amtD10", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-label clear-padding color-skin",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC3']['80']) + " 500,000 " + _vm._s(_vm.labels['HRES8AXC3']['110']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "data-box "
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-label clear-padding"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC3']['100']))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-box "
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-input clear-padding"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailInvest.amtD11),
      expression: "detailInvest.amtD11"
    }],
    staticClass: "form-control input-text",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "id": "n_name",
      "name": "n_name"
    },
    domProps: {
      "value": (_vm.detailInvest.amtD11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detailInvest, "amtD11", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-label clear-padding color-skin",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC3']['80']) + " 500,000 " + _vm._s(_vm.labels['HRES8AXC3']['110']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "data-box "
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-label clear-padding"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC3']['60']))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-box "
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-input clear-padding"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailInvest.amtD12),
      expression: "detailInvest.amtD12"
    }],
    staticClass: "form-control input-text",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "id": "n_name",
      "name": "n_name"
    },
    domProps: {
      "value": (_vm.detailInvest.amtD12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detailInvest, "amtD12", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-label clear-padding color-skin",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC3']['80']) + " 100,000 " + _vm._s(_vm.labels['HRES8AXC3']['110']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "data-box "
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-label clear-padding"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC3']['70']))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-box "
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-input clear-padding"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailInvest.amtD13),
      expression: "detailInvest.amtD13"
    }],
    staticClass: "form-control input-text",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "id": "n_name",
      "name": "n_name"
    },
    domProps: {
      "value": (_vm.detailInvest.amtD13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detailInvest, "amtD13", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row "
  }, [_c('div', {
    staticClass: "col-xs-12 data-label clear-padding color-skin",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC3']['80']) + " 200,000 " + _vm._s(_vm.labels['HRES8AXC3']['110']))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-083a8b44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres8ax/invest.vue
// module id = 3521
// module chunks = 1